import { CircleCheck } from 'lucide-react'
import { useState } from 'react'

import { useGetBrokersTasksJobs } from 'utils/web_api'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'

const TaskHandlersFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')
  const { data: jobs } = useGetBrokersTasksJobs()

  const taskHandlerOptions: ComboboxFilterOption<string>[] =
    jobs?.map((job) => ({
      label: job.description,
      value: job.id,
    })) ?? []

  const filteredOptions = taskHandlerOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Handler', options: filteredOptions || [] }]}
        placeholder='Search task handlers to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={taskHandlerOptions || []}
          noSelectionText='Task Handler'
          pluralIdentifier='task handlers'
        >
          <CircleCheck size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default TaskHandlersFilter
